
import { Component, Vue } from 'vue-property-decorator';
import MemberCollection from '@/components/Member/MemberCollection.vue';
import { Route } from 'vue-router';
import api from '@/api';
import Util from '@/utils/util';

const { member } = api;

@Component({
  components: {
    MemberCollection,
  },
})
export default class UserAuthList extends Vue {
  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private panel = 0;

  private loading = false;

  private orders = [
    { text: '資料更新時間＞舊->新', value: true },
    { text: '資料更新時間＞新->舊', value: false },
  ];

  private filter = {
    q: this.$route.query.q || undefined,
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
    isAsc: (this.$route.query.isAsc || 'true') === 'true',
  };

  private async query() {
    const query = {
      q: this.filter.q,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
      isAsc: `${this.filter.isAsc}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async reset() {
    this.filter = {
      q: undefined,
      pageSize: 20,
      pageNo: 1,
      isAsc: true,
    };
    await this.query();
  }

  private async requestData() {
    this.loading = true;
    const { data } = await member.authList(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async search() {
    this.filter.pageNo = 1;
    await this.query();
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: UserAuthList) => void) => void,
  ) {
    next(async (vm) => {
      await vm.requestData();
    });
  }
}
